import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import { getMapSearchMarkerCap, getMapSearchPageSize } from 'constants/searchHelpers'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useMemo } from 'react'

/**
 * Map search paging for the geographic diversity experiment.
 *
 * `geoDiversityEnabled` uses `isAnyVariant` from `useExperiment`, which is true only
 * for non-control buckets via `getExperimentEnabledDecision`.
 */
export default function useMapSearchPaging() {
  const { isAnyVariant: geoDiversityEnabled } = useExperiment(
    Experiments.searchMapGeographicDiversity,
    { canActivate: true },
  )

  return useMemo(() => {
    const pageSize = getMapSearchPageSize(geoDiversityEnabled, config.search.mapView)

    return {
      geoDiversityEnabled,
      pageSize,
      markerCap: getMapSearchMarkerCap(pageSize, config.search.mapView),
    }
  }, [geoDiversityEnabled])
}
